import React from "react";

import './ModalUnderlayer.css'

export default function ModalUnderlayer({ applicationModal, applicationModalOpened, menuModal, menuModalOpened, modalUnderlayer, modalUnderlayerOpened }) {


    const closeCurrentModal = () => {
        const navigationBarApplicationModalButtonColor = document.getElementById('NavigationBar-ApplicationModal-Button')
        const navigationBarApplicationModalButtonPTag = document.getElementById('NavigationBar-ApplicationModal-Button-P-Tag')
        const navigationBarMenuModalButtonColor = document.getElementById('NavigationBar-MenuModal-Button')
        const navigationBarMenuModalButtonPTag = document.getElementById('NavigationBar-MenuModal-Button-P-Tag')

        const applicationModalAnimation = document.getElementById('Application-Modal')
        const menuModalAnimation = document.getElementById('Menu-Modal')

        const modalUnderLayerAnimation = document.getElementById('Modal-Underlayer')
        if (navigationBarApplicationModalButtonPTag.textContent === 'Close Apps' && navigationBarMenuModalButtonPTag.textContent === 'Open Menu') {
            navigationBarApplicationModalButtonColor.className = 'NavigationBar-ModalButton-Color-Closed NavigationBar-Buttons-Dimensions'
            navigationBarApplicationModalButtonPTag.textContent = 'Open Apps'

            applicationModalAnimation.className = 'Modal-Colors ApplicationModal-Animation-Closed ApplicationModal-Dimensions ApplicationModal-Position ApplicationModal-Shape'

            modalUnderLayerAnimation.className = 'ModalUnderlayer-Colors-Closed ModalUnderlayer-Position ModalUnderlayer-Dimensions'
            setTimeout(() => {
                applicationModalOpened(!applicationModal)
                modalUnderlayerOpened(!modalUnderlayer)
            }, 285);
        } else {
            if (navigationBarApplicationModalButtonPTag.textContent === 'Open Apps' && navigationBarMenuModalButtonPTag.textContent === 'Close Menu') {
                navigationBarMenuModalButtonColor.className = 'NavigationBar-ModalButton-Color-Closed NavigationBar-Buttons-Dimensions'
                navigationBarMenuModalButtonPTag.textContent = 'Open Menu'
    
                menuModalAnimation.className = 'Modal-Colors MenuModal-Animation-Closed MenuModal-Position MenuModal-Position MenuModal-Shape MenuModal-Dimensions'

                modalUnderLayerAnimation.className = 'ModalUnderlayer-Colors-Closed ModalUnderlayer-Position ModalUnderlayer-Dimensions'
                setTimeout(() => {
                    menuModalOpened(!menuModal)
                    modalUnderlayerOpened(!modalUnderlayer)
                }, 285);
            }
        }
 
    }

    return (
        <div onClick={closeCurrentModal} id='Modal-Underlayer' className="ModalUnderlayer-Colors-Opened ModalUnderlayer-Position ModalUnderlayer-Dimensions">
        </div>
    )
}